// extracted by mini-css-extract-plugin
export default {"card":"CartaoDados_card__Xd401"};